{
    "ChangeLang_Title": "Cambia lingua",
    "ChangeLang_Subtitle": "Seleziona la lingua in cui desideri visualizzare il contenuto della pagina web durante la sessione web corrente su questo computer.",
    "ChangeLang_Field_Label": "Lingua",
    "ChangeLang_Remember_Label": "Ricorda la mia selezione",
    "ChangeLang_Buttons_Apply": "Fare domanda a",
    "ChangeLang_Buttons_Cancel": "Cancellare",
    "NAME": "ChangeLangLanguage"
}